function ScrollIntoSlide(slide, instanceClass = undefined) {
    instanceClass = instanceClass ? `.${instanceClass}` : '';
    const slides = [...document.querySelectorAll(`.slide${instanceClass}`)];
    slides.forEach(element => element.getAttribute('data-name') == slide ? element.scrollIntoView() : null);
}

export default ScrollIntoSlide;